import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, Col, FormGroup, Input, Label, Row } from "reactstrap";
import _ from "lodash";
import { ItemTypeahead } from "../../components";
import { api, constants, helpers, dateHelpers } from "../../utils";
import { DesktopContainer } from "../../layouts";
import { useGetItemClasses } from "../../hooks";
import axios from "axios";
import { toast } from "react-toastify";
import Select from "react-select";
import DatePicker from "react-datepicker";
import classNames from "classnames";

const today = new Date().toISOString();

export default function ProductionReports(props) {
   const { ClassList } = useGetItemClasses({ All: "" });
   const [showA, setShowA] = useState(false);
   const [showB, setShowB] = useState(true);
   const [form, setForm] = useState({
      productionReportPayload: {
         productionReportType: 1,
         startDate: today,
         endDate: today,
         productionReportClass: "Week Totals By Day",
         caseNumber: "",
         classNameList: [],
         itemNumber: null,
      },
      moveHistoryPayload: {
         itemNumber: null,
         startDate: today,
         endDate: today,
         moveHistoryReportClass: "Detail Report",
      },
   });

   useEffect(() => {
      const cancelToken = axios.CancelToken;
      const source = cancelToken.source();

      // code here
      return () => {
         source.cancel("axios request cancelled");
      };
   }, []);

   function combineDateTime(date) {
      let newDate = new Date(date);
      let offset = newDate.getTimezoneOffset();
      offset = offset / 60;
      newDate.setHours(0 - offset, 0, 0);
      return dateHelpers.momentFromString(newDate, "MM/DD/YYYY hh:mm:ss A");
   }

   const handleEndDateChange = (date, moveHistory = false) => {
      if (moveHistory) {
         setForm({
            ...form,
            moveHistoryPayload: {
               ...form.moveHistoryPayload,
               endDate: date ? date.toISOString() : null,
            },
         });
      } else {
         setForm({
            ...form,
            productionReportPayload: {
               ...form.productionReportPayload,
               endDate: date ? date.toISOString() : null,
            },
         });
      }
   };

   const handleMoveHistoryClassChange = (event) => {
      setForm({
         ...form,
         moveHistoryPayload: {
            ...form.moveHistoryPayload,
            moveHistoryReportClass: event.target.value,
         },
      });
   };

   const handleRadioChange = (event) => {
      const value = parseInt(event.target.value);
      setForm({
         ...form,
         productionReportPayload: {
            ...form.productionReportPayload,
            productionReportType: value,
         },
      });
   };

   const handleReportClassChange = (event) => {
      setForm({
         ...form,
         productionReportPayload: {
            ...form.productionReportPayload,
            productionReportClass: event.target.value,
         },
      });
   };

   const handleStartDateChange = (date, moveHistory = false) => {
      if (moveHistory) {
         setForm({
            ...form,
            moveHistoryPayload: {
               ...form.moveHistoryPayload,
               startDate: date ? date.toISOString() : null,
            },
         });
      } else {
         setForm({
            ...form,
            productionReportPayload: {
               ...form.productionReportPayload,
               startDate: date ? date.toISOString() : null,
            },
         });
      }
   };

   function isStartDateWithin7Days(startDate, endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);
      const diffInMilliseconds = end.getTime() - start.getTime();
      const diffInDays = diffInMilliseconds / (1000 * 60 * 60 * 24);
      return diffInDays < 7; // Updated the condition to strictly less than 7 days
   }

   const onChange = (property, value) => {
      let copy = _.cloneDeep(form);
      _.set(copy, property, value);
      setForm(copy);
   };

   function showHistoryReport() {
      const payload = Object.assign({}, form.moveHistoryPayload);
      payload.startDate = combineDateTime(form.moveHistoryPayload.startDate);
      payload.endDate = combineDateTime(form.moveHistoryPayload.endDate);
      payload.itemNumber = helpers.valueFromSelect(form.moveHistoryPayload.itemNumber);
      api
         .postDownloadBinary(
            "Report/GetMoveHistoryReportByClass",
            payload,
            constants.MIME_TYPES.pdf,
            `Move_Orders_${dateHelpers.monthDayAndYear(Date.now())}.pdf`,
            "There was an error downloading the Move Order Report pdf."
         )
         .then((res) => {
            if (res?.data === false) {
               toast.error(res.message);
            }
         })
         .catch(api.catchHandler);
   }

   function showProdReport() {
      const payload = Object.assign({}, form.productionReportPayload);
      payload.startDate = combineDateTime(form.productionReportPayload.startDate);
      payload.endDate = combineDateTime(form.productionReportPayload.endDate);
      payload.classNameList = helpers.getCommaDelimitedString(payload.classNameList);
      payload.itemNumber = helpers.valueFromSelect(payload.itemNumber);
      if (!payload.productionReportClass) {
         toast.error("error report class may not be null, contact an admin..");
         return;
      }
      if (!payload.startDate) {
         toast.error("error please select a start date.");
         return;
      }
      if (!payload.endDate) {
         toast.error("error please select a end date.");
         return;
      }
      if (
         payload.productionReportClass === "Week Totals By Day" &&
         isStartDateWithin7Days(payload.startDate, payload.endDate) === false
      ) {
         toast.error(
            "End Date is more then 7 days after the Start Date. The Selected Report only accepts a range of up to seven days."
         );
         return;
      }
      api
         .postDownloadBinary(
            "Report/GetProductionReportByClass",
            payload,
            constants.MIME_TYPES.pdf,
            `Production_Cases_${dateHelpers.monthDayAndYear(Date.now())}.pdf`,
            "There was an error downloading the Production Case Report pdf."
         )
         .then((res) => {
            if (res?.data === false) {
               toast.error(res.message);
            }
         })
         .catch(api.catchHandler);
   }

   const reportClassTypes = {
      "Total Case Detail Report": 1,
      "Total Item Summary Report": 2,
      "Week Totals By Day": 3,
   };

   const moveHistoryTypes = {
      "Detail Report": 1,
      "Summary Report": 2,
   };

   const customStyles = {
      menuList: (provided, state) => ({
         ...provided,
         maxHeight: "120px", // Adjust this value to control the height of the scrollable area
         overflowY: "auto",
      }),
   };

   return (
      (document.title = `Production Reports`),
      (
         <DesktopContainer screenName={"Production Reports"}>
            <div className="filter-header sticky-top">
               <div className="dashboard-button-container">
                  <Button
                     children={"Move Order History"}
                     className="filter-button"
                     onClick={() => setShowA(!showA)}
                     active={showA}
                  />
                  <Button
                     children={"Production Reports"}
                     className="filter-button"
                     onClick={() => setShowB(!showB)}
                     active={showB}
                  />
               </div>
            </div>

            {showB ? (
               <Card className="dashboard-card">
                  <CardBody>
                     <div>
                        <span className="h2 me-2">All Production Reports</span>
                     </div>
                     <hr />
                     <Row className={classNames("", {"mb-5": form.productionReportPayload.productionReportType === 2,})} >
                        <Col xxl={{ offset: 4, size: 1 }}>
                           <FormGroup tag="fieldset">
                              <FormGroup check>
                                 <Label check>
                                    <Input
                                       type="radio"
                                       name="radio1"
                                       value={1}
                                       checked={form.productionReportPayload.productionReportType === 1}
                                       onChange={handleRadioChange}
                                    />{" "}
                                    <h5>All</h5>
                                 </Label>
                              </FormGroup>
                              <FormGroup check>
                                 <Label check>
                                    <Input
                                       type="radio"
                                       name="radio1"
                                       value={2}
                                       checked={form.productionReportPayload.productionReportType === 2}
                                       onChange={handleRadioChange}
                                    />{" "}
                                    <h5>By Class</h5>
                                 </Label>
                              </FormGroup>
                              <FormGroup check>
                                 <Label check>
                                    <Input
                                       type="radio"
                                       name="radio1"
                                       value={3}
                                       checked={form.productionReportPayload.productionReportType === 3}
                                       onChange={handleRadioChange}
                                    />{" "}
                                    <h5>By Item</h5>
                                 </Label>
                              </FormGroup>
                              <FormGroup check>
                                 <Label check>
                                    <Input
                                       type="radio"
                                       name="radio1"
                                       value={4}
                                       checked={form.productionReportPayload.productionReportType === 4}
                                       onChange={handleRadioChange}
                                    />{" "}
                                    <h5>By Case</h5>
                                 </Label>
                              </FormGroup>
                           </FormGroup>
                        </Col>
                        <Col
                           xxl={4}
                           style={{ marginTop: "90px" }}
                           className={classNames({"d-none": form.productionReportPayload.productionReportType !== 4,})}
                        >
                           <Input
                              type="text"
                              placeholder="Type the case number you are looking for.."
                              value={form.productionReportPayload.caseNumber}
                              onChange={(e) => {
                                 if (e) {
                                    setForm({
                                       ...form,
                                       productionReportPayload: {
                                          ...form.productionReportPayload,
                                          caseNumber: e.target.value,
                                       },
                                    });
                                 }
                              }}
                           />
                        </Col>
                        <Col
                           xxl={4}
                           style={{ marginTop: "60px" }}
                           className={classNames({"d-none": form.productionReportPayload.productionReportType !== 3,})}
                        >
                           <ItemTypeahead
                              value={form.productionReportPayload.itemNumber}
                              onChange={(opt) =>
                                 setForm({
                                    ...form,
                                    productionReportPayload: {
                                       ...form.productionReportPayload,
                                       itemNumber: opt,
                                    },
                                 })
                              }
                           />
                        </Col>
                        <Col
                           xxl={4}
                           style={{ marginTop: "30px" }}
                           className={classNames({"d-none": form.productionReportPayload.productionReportType !== 2,})}
                        >
                           {
                              <Select
                                 classNamePrefix="serviceThreadSelect"
                                 options={ClassList}
                                 value={form.productionReportPayload.classNameList}
                                 onChange={(e) =>
                                    _.isNil(e)
                                       ? setForm({
                                          ...form,
                                          productionReportPayload: {
                                             ...form.productionReportPayload,
                                             classNameList: [],
                                          },
                                       })
                                       : setForm({
                                          ...form,
                                          productionReportPayload: {
                                             ...form.productionReportPayload,
                                             classNameList: e,
                                          },
                                       })
                                 }
                                 styles={customStyles}
                                 placeholder={"Type the item class you are looking for..."}
                                 isMulti={true}
                              />
                           }
                        </Col>
                     </Row>
                     <Row className="mb-2 mt-2">
                        <Col xxl={{ offset: 4, size: 8 }}>
                           <Row className="mb-2">
                              <Label for="startDate" sm={2}>
                                 <h5>Start Date:</h5>
                              </Label>
                              <Col>
                                 <DatePicker
                                    id="startDate"
                                    className="form-control"
                                    selected={
                                       form.productionReportPayload.startDate
                                          ? new Date(form.productionReportPayload.startDate)
                                          : null
                                    }
                                    onChange={(date) => handleStartDateChange(date, false)}
                                    placeholderText="Start Date"
                                    dateFormat="MM/dd/yyyy"
                                    isClearable
                                 />
                              </Col>
                           </Row>
                           <Row>
                              <Label for="endDate" sm={2}>
                                 <h5>End Date:</h5>
                              </Label>
                              <Col>
                                 <DatePicker
                                    id="endDate"
                                    className="form-control"
                                    selected={
                                       form.productionReportPayload.endDate
                                          ? new Date(form.productionReportPayload.endDate)
                                          : null
                                    }
                                    onChange={(date) => handleEndDateChange(date, false)}
                                    placeholderText="End Date"
                                    dateFormat="MM/dd/yyyy"
                                    isClearable
                                 />
                              </Col>
                           </Row>
                        </Col>
                     </Row>
                     <Row className="mt-2">
                        <Col xxl={{ offset: 4, size: 4 }}>
                           <FormGroup tag="fieldset">
                              {Object.keys(reportClassTypes).map((key) => (
                                 <Row key={key}>
                                    <Col>
                                       <FormGroup check>
                                          <Input
                                             type="radio"
                                             name="reportClass"
                                             value={key}
                                             checked={form.productionReportPayload.productionReportClass === key}
                                             onChange={handleReportClassChange}
                                          />
                                          <Label check>{<h5>{key}</h5>}</Label>
                                       </FormGroup>
                                    </Col>
                                 </Row>
                              ))}
                           </FormGroup>
                        </Col>
                     </Row>
                     <Row>
                        <Col xxl={{ offset: 4, size: 4 }}>
                           <Button
                              className={"shredButton"}
                              children={"Show Report"}
                              onClick={() => showProdReport()}
                           />
                        </Col>
                     </Row>
                  </CardBody>
               </Card>
            ) : ( false )}

            {showA ? (
               <Card className="dashboard-card">
                  <CardBody>
                     <div>
                        <span className="h2 me-2">Move Order History Reports</span>
                     </div>
                     <hr />
                     <Row className="mb-2">
                        <Col xxl={{ offset: 4, size: 8 }}>
                           <Row>
                              <Label for="itemTypeAhead" sm={2}>
                                 <h5>Item:</h5>
                              </Label>
                              <Col xxl={4}>
                                 <ItemTypeahead
                                    id="itemTypeAhead"
                                    value={form.moveHistoryPayload.itemNumber}
                                    onChange={(e) => onChange("moveHistoryPayload.itemNumber", e)}
                                    disabled={false}
                                 />
                              </Col>
                           </Row>
                        </Col>
                     </Row>
                     <Row className="mb-2">
                        <Col xxl={{ offset: 4, size: 8 }}>
                           <Row className="mb-2">
                              <Label for="startDate" sm={2}>
                                 <h5>Start Date:</h5>
                              </Label>
                              <Col>
                                 <DatePicker
                                    id="startDate"
                                    className="form-control"
                                    selected={
                                       form.moveHistoryPayload.startDate
                                          ? new Date(form.moveHistoryPayload.startDate)
                                          : null
                                    }
                                    onChange={(date) => handleStartDateChange(date, true)}
                                    placeholderText="Start Date"
                                    dateFormat="MM/dd/yyyy"
                                    isClearable
                                 />
                              </Col>
                           </Row>
                           <Row>
                              <Label for="endDate" sm={2}>
                                 <h5>End Date:</h5>
                              </Label>
                              <Col>
                                 <DatePicker
                                    id="endDate"
                                    className="form-control"
                                    selected={
                                       form.moveHistoryPayload.endDate
                                          ? new Date(form.moveHistoryPayload.endDate)
                                          : null
                                    }
                                    onChange={(date) => handleEndDateChange(date, true)}
                                    placeholderText="End Date"
                                    dateFormat="MM/dd/yyyy"
                                    isClearable
                                 />
                              </Col>
                           </Row>
                        </Col>
                     </Row>
                     <Row className="mt-2">
                        <Col xxl={{ offset: 4, size: 4 }}>
                           <FormGroup tag="fieldset">
                              {Object.keys(moveHistoryTypes).map((key) => (
                                 <Row key={key}>
                                    <Col>
                                       <FormGroup check>
                                          <Input
                                             type="radio"
                                             name="moveHistory"
                                             value={key}
                                             checked={form.moveHistoryPayload.moveHistoryReportClass === key}
                                             onChange={handleMoveHistoryClassChange}
                                          />
                                          <Label check>{<h5>{key}</h5>}</Label>
                                       </FormGroup>
                                    </Col>
                                 </Row>
                              ))}
                           </FormGroup>
                        </Col>
                     </Row>
                     <Row>
                        <Col xxl={{ offset: 4, size: 4 }}>
                           <Button
                              className={"shredButton"}
                              children={"Show Report"}
                              onClick={() => showHistoryReport()}
                           />
                        </Col>
                     </Row>
                  </CardBody>
               </Card>
            ) : (false)}

         </DesktopContainer>
      )
   );
}
